document.querySelectorAll('.index-contents-with-logos-slider').forEach(el => {
  if (!el.classList.contains('swiper-initialized')) {
    new Swiper(el, {
        loop: true,
        grabCursor: false,
        spaceBetween: 0,
        slidesPerGroup: 1,
        slidesPerView: 1,
        watchSlidesProgress: true,
        autoHeight: false,
        watchOverflow: true,
        threshold: 10,
        mousewheel: {
            forceToAxis: !0
        },
        observer: true,
        observeParents: true,
        freeMode: false,
        effect: "fade",
        speed: 300,
        fadeEffect: {
            crossFade: true,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        }
    })
  }
});